import { createSlice } from "@reduxjs/toolkit";
import { FeriadoModel } from "../../../models/feriado/feriadoModel";
import { buscarFeriado } from "../../../services/feriadoService";
import { BuscarFeriadoModel } from "../../../models/feriado/chamadas/buscarFeriadoModel";
import { resetAll } from "../../actions/actions";
import dayjs from "dayjs";

dayjs.locale("pt-br");

export interface FeriadoState {
  //buscar feriado
  loading: boolean;
  busca: BuscarFeriadoModel;
  list: FeriadoModel[];
  entity: FeriadoModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: FeriadoState = {
  //buscar feriado
  loading: false,
  busca: {
    pesquisar: null,
    dataInicio: dayjs().startOf("month").toDate(),
    dataFim: dayjs().endOf("month").toDate(),
  } as BuscarFeriadoModel,
  list: [],
  //internal
  entity: {} as FeriadoModel,
  modalCadastrar: false,
  modalDeletar: false,
};

export const feriadoSlice = createSlice({
  name: "feriado",
  initialState,
  reducers: {
    //buscar feriado
    setBuscaFeriado: (state, action) => {
      state.busca = action.payload;
    },
    setEntityFeriado: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarFeriado: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarFeriado: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar feriado
    builder.addCase(buscarFeriado.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarFeriado.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarFeriado.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar feriado
  setBuscaFeriado,
  setEntityFeriado,
  //interal
  setModalCadastrarFeriado,
  setModalDeletarFeriado,
} = feriadoSlice.actions;

export default feriadoSlice.reducer;
